import React from "react";

// ========== STORY MODE QUIZ ========== //
import teacherPNG from "../../UserProfile/Teacher.png"; 

// ...
export function StoryModeQuiz({
  questions,
  onAnswer,
  currentIndex,
  score,
  user, // Accept user object!
  teacherAvatar = teacherPNG,
  showCalc,
  showPad,
  onToggleCalc,
  onTogglePad,
  tools
}) {
  const current = questions[currentIndex];
  if (!current) return <p>Loading quiz...</p>;
console.log("🪪 StoryModeQuiz user.avatar = ", user?.avatar);
let studentAvatarSrc = user?.avatar || user?.profilePic || `${process.env.PUBLIC_URL}/images/Student.png`;

  // robust patch
  if (
    studentAvatarSrc &&
    !studentAvatarSrc.startsWith("/") &&
    !studentAvatarSrc.startsWith("http")
  ) {
    studentAvatarSrc = `/avatars/${studentAvatarSrc}`;
  }

  return (
    <div className="quick-quiz-story-mode">
      <div className="quiz-top-panel">
        <div className="teacher-image-container">
          <img src={teacherAvatar} alt="Teacher" className="quiz-character-img" />
        </div>
        <div className="quiz-question-box">
          <p className="quiz-question-text">{current.question}</p>
          {current.visual && <div>{current.visual}</div>}
        </div>
      </div>
      <div className="quiz-bottom-panel">
        <div className="quiz-answer-box-left">
          {current.options.map((opt, i) => (
            <button key={i} className="quiz-answer-btn" onClick={() => onAnswer(opt)}>
              {opt}
            </button>
          ))}
          <p className="quiz-score-display">
            Score: {score}/{questions.length}
          </p>
          {onToggleCalc && (
            <button className="button1" onClick={onToggleCalc}>
              {showCalc ? "Hide Calculator" : "Show Calculator"}
            </button>
          )}
          {onTogglePad && (
            <button className="button1" onClick={onTogglePad}>
              {showPad ? "Hide Writing Pad" : "Show Writing Pad"}
            </button>
          )}
          {tools}
        </div>
        <div className="student-image-container">
          <img
            src={studentAvatarSrc}
            alt="Student"
            className="quiz-character-img-student"
          />
        </div>
      </div>
    </div>
  );
}


// ========== QUIZ RESULT SCREEN ========== //
export function QuizResultScreen({
  score,
  total,
  onContinue,
  onRetry,
  continueLabel = "Continue",
  retryLabel = "Retry",
  children
}) {
  return (
    <div className="quiz-result-screen">
      <h3>Quiz Finished!</h3>
      <p>You scored {score} out of {total}.</p>
      {children}
      <div className="quiz-result-actions">
        {onContinue && (
          <button className="quiz-result-btn" onClick={onContinue}>
            {continueLabel}
          </button>
        )}
        {onRetry && (
          <button className="quiz-result-btn" onClick={onRetry}>
            {retryLabel}
          </button>
        )}
      </div>
    </div>
  );
}

// ========== FINAL QUIZ UI (with Timer, Award Logic) ========== //
export function FinalQuizUI({
  questions,
  currentIndex,
  score,
  timeLeft,
  onAnswer,
  quizFinished,
  onReturn,
  resultMsg,
  children
}) {
  const current = questions[currentIndex];
  if (!questions.length) return <p>Loading final quiz...</p>;

  return (
    <div className="final-quiz-container">
      {!quizFinished ? (
        <>
          <h2 className="final-quiz-title">Final Quiz ({questions.length} Questions)</h2>
          {timeLeft !== undefined && (
            <p className="final-quiz-timer">
              Time Left: {Math.floor(timeLeft / 60)}:{String(timeLeft % 60).padStart(2, "0")}
            </p>
          )}
          <p className="final-quiz-progress">
            Question {currentIndex + 1} / {questions.length}:
          </p>
          <p className="final-quiz-question">{current.question}</p>
          <div className="final-quiz-options">
            {current.options.map((opt, i) => (
              <button
                key={i}
                className="final-quiz-option"
                onClick={() => onAnswer(opt)}
              >
                {opt}
              </button>
            ))}
          </div>
          <p className="final-quiz-score">Score: {score}</p>
          {children}
        </>
      ) : (
        <div className="final-quiz-finished">
          <h3 className="final-quiz-finished-title">Final Quiz Completed!</h3>
          {resultMsg || (
            <p className="final-quiz-finished-score">
              You scored {score} out of {questions.length}.
            </p>
          )}
          <button className="final-quiz-finish-btn" onClick={onReturn}>
            Return to Lesson
          </button>
        </div>
      )}
    </div>
  );
}

// Optionally, default export all as named
const QuizUIModule = {
  StoryModeQuiz,
  QuizResultScreen,
  FinalQuizUI
};

export default QuizUIModule;
